import { gql, useQuery } from "@apollo/client";
import { SELECT_OPTION_FIELDS, SelectOptionType } from "graphql/types/SelectOptionType";

export const GET_ALL_CONTRACTING_PARTIES = gql`
    query GetAllContractingParties {
        getAllContractingParties {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;

interface GetAllContractingPartiesResponse {
    getAllContractingParties: SelectOptionType[];
}

export const useAllContractingParties = () => {
    const { data, loading, error } = useQuery<GetAllContractingPartiesResponse>(
        GET_ALL_CONTRACTING_PARTIES,
        {
            fetchPolicy: 'cache-and-network'
        }
    );

    return {
        contractingParties: data?.getAllContractingParties || [],
        loading,
        error
    };
};
